import { InputFormTypeAllType } from "../../../types.ts";
import { RadioBlockItemType } from "@config/app/questionTemplates/types.ts";
import { InputCheckBoxInline } from "@components/Input/mod.ts";

export const InputCheckboxForEmail = (
  {
    value,
    data: {
      id,
      label,
      content: {
        choices,
      },
    },
    onSuccess,
  }: InputFormTypeAllType<{
    data: RadioBlockItemType;
  }>,
) => {
  return (
    <InputCheckBoxInline
      name={label}
      value={value}
      id={id}
      fields={choices}
      onSuccess={onSuccess}
    />
  );
};
